module.exports = __webpack_public_path__ + "static/media/Mummy Queen.2a64652d.jpg";